var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect, useRef } from "react";
import Loader from "./loader";
export const DropdownItemWrapper = ({ value, children }) => children;
export const Dropdown = ({ value, children, onItemSelect, overrideOnClick = false, render, extraClass = "", onOpen, onClose, loading = false, loadingText = null, prompt = "select value", }) => {
    const [isOpen, setOpen] = useState(false);
    const node = useRef();
    //https://codesandbox.io/s/9o3lw5792w
    const handleClickOutside = (e) => {
        //@ts-ignore
        if (node.current.contains(e.target)) {
            // inside click
            return;
        }
        close();
    };
    useEffect(() => {
        //@ts-ignore
        if (isOpen !== null) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);
    const open = () => __awaiter(void 0, void 0, void 0, function* () {
        if (onOpen) {
            yield onOpen();
        }
        setOpen(true);
    });
    const close = () => {
        if (onClose) {
            onClose();
        }
        setOpen(false);
    };
    return (React.createElement("div", { className: `dropdown ${extraClass} ${isOpen ? "open" : "closed"}`, ref: node },
        loading ? (React.createElement(Loader, { text: loadingText })) : (React.createElement("div", { className: "dropdownBox", onClick: open },
            value ? value : prompt,
            React.createElement("div", { className: "indicator" }))),
        isOpen ? (React.createElement("div", { className: "dropdownMenu" }, React.Children.map(render ? render({ open, close, isOpen }) : children, (child, index) => {
            return (React.createElement("div", { onClick: (e) => {
                    if (!overrideOnClick) {
                        onItemSelect(child.props.value);
                        close();
                    }
                }, className: "cell", key: index }, React.cloneElement(child, Object.assign({}, child.props))));
        }))) : null));
};
